import { render, staticRenderFns } from "./BaiDu.vue?vue&type=template&id=e44631dc&scoped=true"
import script from "./BaiDu.vue?vue&type=script&lang=js"
export * from "./BaiDu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44631dc",
  null
  
)

export default component.exports